export enum LocaleType {
	EN_US = 'en-US',
}

export enum CurrencyType {
	USD = 'USD',
}
